import { call, put, takeLatest } from 'redux-saga/effects';

import * as trustActions from './trustActions';
import { updateTrustApiCall } from './trustAPI';

function* updateTrustSaga({ payload }) {
  try {
    const { data } = yield call(updateTrustApiCall, payload);
    // yield put(trustActions.trustUpdateStore(data));
  } catch (error) {
    yield put(trustActions.trustUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* trustWatcher() {
  yield takeLatest(trustActions.trustUpdateRequest.type, updateTrustSaga);
}
